module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPinchIn),
      expression: "showPinchIn"
    }],
    staticClass: "pinch-in-card"
  }, [_c('div', {
    staticClass: "modal-inner flexcenter"
  }, [_c('div', {
    staticClass: "pinch-type card-voice"
  }, [_c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.clickClose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pinch-inInner"
  }, [_c('div', {
    staticClass: "item"
  }, [(_vm.pinchInAct != null) ? _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "select"
  }, [(_vm.pinchTileText != null) ? [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pinchInShowAnswerText),
      expression: "pinchInShowAnswerText"
    }],
    class: _vm.getPinchInTextFontclassAct(_vm.pinchTileText.answerText, _vm.$parent.productLanguage),
    domProps: {
      "innerHTML": _vm._s(_vm.pinchTileText.answerText)
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pinchInShowAnswerText),
      expression: "!pinchInShowAnswerText"
    }],
    class: _vm.getPinchInTextFontclassAct(_vm.pinchTileText.answerText, _vm.$parent.productLanguage),
    domProps: {
      "innerHTML": _vm._s(_vm.pinchTileText.questionText)
    }
  })] : [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pinchInShowTextAct),
      expression: "pinchInShowTextAct"
    }],
    class: _vm.getPinchInTextFontclassAct(_vm.pinchInDispText, _vm.$parent.productLanguage),
    domProps: {
      "innerHTML": _vm._s(_vm.pinchInDispText)
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.horizontalRow),
      expression: "!horizontalRow"
    }],
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pinchInAct.image
    }
  }), _vm._v(" "), (_vm.pinchImageText) ? _c('p', {
    class: _vm.pinchImageTextFontClass
  }, [_vm._v("\n                    " + _vm._s(_vm.pinchImageText) + "\n                  ")]) : _vm._e()]), _vm._v(" "), (_vm.horizontalRow && _vm.checkIsComplete()) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pinchInAct.image
    }
  }), _vm._v(" "), (_vm.pinchImageText) ? _c('p', {
    class: _vm.pinchImageTextFontClass
  }, [_vm._v("\n                    " + _vm._s(_vm.pinchImageText) + "\n                  ")]) : _vm._e()]) : (_vm.horizontalRow) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/blank.jpg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pinchInShowVoice),
      expression: "pinchInShowVoice"
    }],
    staticClass: "icon-voice",
    on: {
      "click": function($event) {
        return _vm.pinchinActAudioPlay()
      }
    }
  })])]) : _vm._e()])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ba99f2b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-ba99f2b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/PinchInActStore.vue
// module id = 885
// module chunks = 1